import { Images, ChevronRight } from 'lucide-react'
import { useLocation } from 'wouter'
import { getImageUrls } from '@/utils/image-urls'

export interface Gallery {
  id: number | string
  heading: string
  page_title?: string
  content?: string
  filename?: string
  filename_alt?: string
  page_url?: string
  published_date?: string
  category_id?: number | null
}

interface GalleryCardProps {
  gallery: Gallery
}

export default function GalleryCard({ gallery }: GalleryCardProps) {
  const [, navigate] = useLocation()

  const handleClick = () => {
    navigate(`/galleries/${gallery.id}`)
  }

  const imageUrls = gallery.filename ? getImageUrls('galleries', gallery.filename) : null

  const formattedDate = gallery.published_date
    ? new Date(gallery.published_date).toLocaleDateString()
    : null

  return (
    <div
      onClick={handleClick}
      className="bg-[#3C3C3C] rounded-xl overflow-hidden hover:bg-[#4C4C4C] transition-colors cursor-pointer group"
    >
      {/* Gallery Thumbnail */}
      <div className="w-full overflow-hidden relative">
        {imageUrls ? (
          <img
            src={imageUrls.landscapeThumb}
            alt={gallery.filename_alt || gallery.heading}
            className="w-full h-auto group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full aspect-video bg-[#2F2F32] flex items-center justify-center">
            <Images className="w-16 h-16 text-[#4C4C4C]" />
          </div>
        )}
      </div>

      {/* Gallery Info */}
      <div className="p-3">
        {/* Title */}
        <h3 className="text-[#ffffff] font-semibold text-sm mb-1 line-clamp-1">
          {gallery.heading}
        </h3>

        {/* Date */}
        <div className="flex items-center justify-between">
          {formattedDate ? (
            <p className="text-[#888888] text-xs">
              {formattedDate}
            </p>
          ) : (
            <span />
          )}

          {/* View Arrow */}
          <ChevronRight className="h-4 w-4 text-[#EF4444] flex-shrink-0" />
        </div>
      </div>
    </div>
  )
}
